import React from 'react';
import OtherPartnersContainer from '../../../Containers/UserContainer/OtherPartners';

const OtherPartnersScreen = () => {
  return <OtherPartnersContainer />;
};

export default OtherPartnersScreen;
